import { call, put, select } from 'typed-redux-saga'

import services from '@services'
import { showError } from '@store/ui/error/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { ApplicationState } from '@store/types'
import { StepRefin } from '@utils/enums'

import { Banco, BancosAPI, GetBancosSagaPayload } from '../types'
import { bancosRequest, bancosSuccess, setBancosError, setBancosLoading } from '../actions'

const bancosBuild = (data: BancosAPI): Banco[] =>
  data?.bancos?.map(({ nome, codigo, ispb }) => ({
    nome,
    codigo,
    ispb,
  }))

export default function* getBancosSaga(action: GetBancosSagaPayload) {
  const { callback, saveToState = true } = action.payload
  const { accessToken } = yield* select((state: ApplicationState) => state.session)

  try {
    const { data } = yield* call(services.getBancosService, accessToken)
    yield put(setLastServiceResponse({ code: 'OK', serviceName: 'getBancosService' }))
    const bancos = data ? bancosBuild(data) : null

    if (saveToState) {
      yield put(bancosSuccess(bancos))
    } else {
      yield put(setBancosLoading(false))
    }

    if (callback) {
      yield* call(callback, bancos)
    }
  } catch (error) {
    yield put(setLastServiceResponse({ code: 'ERROR', serviceName: 'getBancosService' }))
    yield put(setBancosError())
    yield put(
      showError({
        title: 'Erro ao buscar os bancos',
        message: 'Ocorreu um erro na listagem dos bancos.',
        actionTitle: 'Tentar Novamente',
        code: StepRefin.ERRO_BUSCAR_BANCOS,
        actionCallback: () => bancosRequest({ callback, saveToState }),
      }),
    )
  }
}
